const ThemeProvider = {
  /* -- brand colours --*/
  black: "#1b1e1c",
  white: "#ffffff",
  red: "#D22630",
  gray: "#A7A8A9",
  midGray: "#757575",
  lightGray: "#f3f3f3",
  gold: "#856404",
  lightGreen: "#008755",
  lighterGreen: "#BFE9DA",
  editGreen: "#00A76A",
  lightBlue: "#e6edf5",
  lightYellow: "#fff9e6",

  /* --borders --*/
  grayBorder: "2px solid #ccc",
  lightGrayBorder: "1px solid #d0d0ce",
  lightGrayBorderDashed: "1px dashed #d0d0ce"
};

export default ThemeProvider;
